<template>
<div class="chapter">
<div class="inner_page">
<div class="pg">
<p class="image0" id="fm-4"><img alt="Image" src="images/xxviii.jpg"/></p>
<p class="image-caption">Judah in Jeremiah’s Day</p>
</div>
<div class="pg">
<p class="image0"><img alt="Image" src="images/xxix.jpg"/></p>
<p class="image-caption">Empires of the 6th Century BC</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Map.vue?2d094b0a